export default "__VITE_ASSET__C_X1M7Gx__"